function getCookieByName(cookieName: string) {
  const regEx = new RegExp(`(?:^|;)\\s?${cookieName}=(.*?)(?:;|$)`, 'i')
  const match = document.cookie.match(regEx)

  return !!match && match.length > 0 ? decodeURI(match[match.length - 1]) : null
}

export default getCookieByName
